export default __webpack_public_path__ + "static/media/logo.01dae9d5.jpg";